import { Helmet } from 'react-helmet-async'
import ShimmerButton from '../components/ui/ShimmerButton'
import GrantaEarthLogo from '../components/ui/GrantaEarthLogo'

export default function Contact() {
  return (
    <>
      <Helmet>
        <title>Contact | GrantaEarth Co.</title>
        <meta name="description" content="Send a message to the trade desk. We respond quickly to serious investment or supply requests." />
      </Helmet>

      <section className="bg-gradient-to-b from-off-white to-white section-padding">
        <div className="container-custom grid md:grid-cols-2 gap-10">
          <div>
            <h1 className="text-3xl md:text-5xl font-extrabold">Contact</h1>
            <p className="mt-4 text-gray-700">
              Tell us about your requirement. Include desired timelines, quantities, and any compliance requirements.
            </p>
            
            <div className="mt-8 space-y-6">
              <div className="bg-deep-green text-white p-6 rounded-2xl">
                <h2 className="text-xl font-semibold mb-4">Get in Touch</h2>
                <p className="mb-4">Ready to discuss your mining and commodity requirements? Contact us directly:</p>
                
                <div className="space-y-3">
                  <div className="flex items-center space-x-3">
                    <span className="text-lg">📧</span>
                    <div>
                      <p className="font-medium">Email us at:</p>
                      <a href="mailto:info@grantaearth.com" className="text-green-200 hover:text-white underline">
                        info@grantaearth.com
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-3">
                    <span className="text-lg">📱</span>
                    <div>
                      <p className="font-medium">Call us at:</p>
                      <a href="tel:+263719263479" className="text-green-200 hover:text-white underline">
                        +263719263479
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="relative rounded-2xl border bg-white shadow min-h-[320px]">
            <div className="absolute inset-0 bg-[url('/globe-grid.svg')] bg-center bg-contain opacity-20" />
            <div className="p-6 relative">
              <GrantaEarthLogo size="lg" className="mb-4" />
              <p className="mt-2 text-gray-600">Zimbabwe registered. Operating across Lalapanzi, Zvishavane, and Mutorashanga.</p>
              <div className="mt-4 space-y-1 text-gray-700">
                <p>Email: info@grantaearth.com</p>
                <p>Phone: +263719263479</p>
                <p>Working hours: Mon to Fri</p>
                <p>8Am to 5pm</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
